var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class FilterExpressionOperatorsListener {
  constructor() {
    /// <summary>
    /// Gets the total number of times <c>IN</c>, <c>EQ</c>, <c>==</c> operators are used.
    /// </summary>
    __publicField(this, "equalOperatorsCount", 0);
    /// <summary>
    /// Gets the total number of times <c>NOTIN</c>, <c>!=</c>, <c>&lt;&gt;</c> operators are used.
    /// </summary>
    __publicField(this, "notEqualsOperatorsCount", 0);
    /// <summary>
    /// Gets the total number of times <c>&lt;</c>, <c>&lt;=</c>, <c>&gt;</c>, <c>&gt;=</c>, <c>BETWEEN</c> operators were used.
    /// </summary>
    __publicField(this, "rangeOperatorsCount", 0);
    /// <summary>
    /// Gets the total number of times <c>AND</c>, <c>OR</c> operators were used.
    /// </summary>
    __publicField(this, "logicalOperatorsCount", 0);
    /// <summary>
    /// Gets the total number of times <c>()</c> parentheses/groupping were explicitly used.
    /// </summary>
    __publicField(this, "groupOperatorsCount", 0);
  }
  enterFilterBetween(context) {
    this.rangeOperatorsCount++;
  }
  enterFilterBinary(context) {
    if (context.EQ() != null) {
      this.equalOperatorsCount++;
    } else if (context.NE() != null) {
      this.notEqualsOperatorsCount++;
    } else if (context.GT() != null || context.GE() != null || context.LT() != null || context.LE() != null) {
      this.rangeOperatorsCount++;
    }
  }
  enterFilterIn(context) {
    if (context.IN() != null) {
      this.equalOperatorsCount++;
    } else if (context.NOTIN() != null) {
      this.notEqualsOperatorsCount++;
    }
  }
  enterFilterConjunction(context) {
    this.logicalOperatorsCount++;
  }
  /// <inheritdoc/>
  enterFilterDisjunction(context) {
    this.logicalOperatorsCount++;
  }
  /// <inheritdoc/>
  enterFilterGroup(context) {
    this.groupOperatorsCount++;
  }
}
export {
  FilterExpressionOperatorsListener
};
//# sourceMappingURL=FilterExpressionOperatorsListener.js.map
